<div class="avatar-container">
  <div class="circle" [ngStyle]="{'background-color': color }">
    @if (showPhoto) { <img loading="lazy" [src]="photoURL" /> }
    @else { <div class="initials">{{ initials }}</div> }
  </div>
  @if (showFullName) { <div [ngStyle]="{margin:'0 1rem'}">{{first}} {{last}}</div> }
</div>
